import { isValid, encryptAES128, decryptAES128 } from '../utilitiesmodule';
import VueRouter from 'vue-router';
import moment from 'moment';
import { FileFolderEntityType, ONEServiceTypeInfo, ONEServiceType, ResultValue } from '../objects';

/*****************************STRINGS*****************************************************************************************************/
//Trasforma la stringa nel seguente modo:
// - la mette tutta in lowercase
// - mette in uppercase la prima lettera e le parole che devono essere in maiuscole, definite nell'array uppercaseStrings
String.prototype.titolize = function () {
    var arr = this.split(" ");

    for (var i = 0; i < arr.length; i++) {
        if (uppercaseStrings.includes(arr[i].toUpperCase()))
            arr[i] = arr[i].toUpperCase();
        else if (i == 0)
            arr[0] = arr[0].charAt(0).toUpperCase() + arr[0].substring(1).toLowerCase();
        else
            arr[i] = arr[i].toLowerCase();
    }
    return arr.join(" ");
}


var uppercaseStrings=["CPU", "SSL", "POP", "PC", "ESXI", "FTP", "OS", "TFA", "URL", "2FA", "ID", "RAM", "RCT", "CBT", "SSPI", "POP3", "I/O", "MB", "KB", "GB", "TB", "B", "VHD", "VHDX"];

String.prototype.contains = function (str) {
    return this.indexOf(str) != -1;
}

String.prototype.getSeparator = function () {
    if (this.includes("/")) return "/";
    if (this.includes("\\")) return "\\";
    return "/";
}

String.prototype.lastPartOfPath = function () {
    var separator = this.getSeparator();

    if (this.contains(separator))
        return this.split(separator).at(-1);

    return this;
}

String.prototype.trimEnd = function (endChars) {
    var str = this;
    while (str.endsWith(endChars))
        str = str.slice(0, -(endChars.length));
    return str;
}

String.prototype.trimStart = function (startChars) {
    var str = this;
    while (str.startsWith(startChars))
        str = str.slice(startChars.length);
    return str;
}

String.prototype.getParent = function () {
    var slash = this.getSeparator();
    var str = this;
    var strParts = str.split(slash).filter(p => p != "");

    if (strParts.length == 1)
        return "";

    strParts.pop(); // rimuovo l'ultimo pezzo
    str = strParts.join(slash)

    if (this.startsWith("\\\\")) {
        str = "\\\\" + str;
    }
    return str;
}

String.prototype.GetFoldersNames = function (platformType = null) {
    var slash = platformType == null ?
        this.getSeparator() :
        platformType.getSeparator();
    var str = this;

    var newPath = str.trimEnd(slash);

    if (!newPath.includes(slash))
        return [newPath];

    return newPath.split(slash);
}

String.prototype.getAllPaths = function (platformType) {
    var folders = this.GetFoldersNames(platformType);
    if (folders.length == 1) {
        return folders;
    }

    var paths = [];
    var slash = platformType.getSeparator();

    folders.forEach(f => {
        if (paths.length == 0) {
            paths.push(f);
        } else {
            paths.push(paths.at(-1) + slash + f);
        }
    })

    return paths;
}

String.prototype.format = function (...params) {
    var str = this;
    for (var i = 0; i < params.length; i++) {
        str = str.replaceAll("{" + i + "}", params[i]);
    }
    return str;
}



String.prototype.applyBucketsRules = function () {
    var str = this;
    var pathArray = str.split("/");
    var nParts = pathArray.length;
    var mainFolder = pathArray[0];
    var subPath = nParts == 1 ? "" : str.split(mainFolder + "/")[1];

    mainFolder = mainFolder.toLowerCase();
    var ascii;
    for (var i = 0; i < mainFolder.length; i++) {
        ascii = mainFolder.charCodeAt(i);
        if (47 < ascii && ascii < 58) continue; // (0-9)
        if (96 < ascii && ascii < 123) continue; // (a-z)
        if (ascii == 46 || ascii == 45) continue; // 46  -> punto , 45 -> trattino
        mainFolder = mainFolder.replace(mainFolder.at(i), "-");
    }

    var path = mainFolder;
    if (subPath != "") {
        path += "/" + subPath
    }

    return [
        path,
        mainFolder,
        subPath,
        nParts
    ];
}

String.prototype.validatePath = function (type, slash) {
    var value = this;
    //Tolgo gli spazi
    value = value.trim();
    //tolgo gli slash all'inizio e alla fine
    var arr = value.split(/[\\\/\:]+/);
    //tolgo i caratteri non ammessi
    arr = arr.filter(p => p != '').map(p => p.validateFSItem());
    if (arr.length == 0) {
        return "";
    }

    if (type == ONEServiceType.FileFolder) {
        if (arr[0].length == 1) {
            arr[0] += ":";
        } else {
            arr[0] = "C:\\" + arr[0];
        }

    } else if (type == ONEServiceType.FTP) {
        arr[0] += ":/";
    } else if (type == ONEServiceType.Network) {
        arr[0] = "\\\\" + arr[0];
    }

    //controllo se il percorso è di tipo ftp e conteneva la porta
    if (arr.length >= 3 && type == ONEServiceType.FTP && !isNaN(arr[2])) {
        arr.splice(2, 1);
    }
    value = arr.join(slash)/*+(value.endsWith(slash)? slash:"")*/;


    return value;
}

String.prototype.validateFSItem = function () {
    var value = this;
    //Tolgo gli spazi
    value = value.trim().replace(/[<>:|?*\\/]/g, '');
    return value;
}

const key = "yHnLo963HvuhEqW4612?--At3hu";


String.prototype.decryptAES128 = function () {
    return decryptAES128(this, key);
}

String.prototype.encryptAES128 = function () {
    return encryptAES128(this, key);
}

String.prototype.isMainURL = function () {
    var subPath = this;
    if (subPath.contains(window.location.origin)) {
        subPath = this.split(window.location.origin)[1];
    }
    return subPath.indexOf('/') == subPath.lastIndexOf('/');
}
/*
Format	English Locale	            Sample Output
LT	    h:mm A	                    8:02 PM
LTS	    h:mm:ss A	                8:02:18 PM
L	    MM/DD/YYYY	                08/16/2018
LL	    MMMM D, YYYY	            August 16, 2018
LLL	    MMMM D, YYYY h:mm A	        August 16, 2018 8:02 PM
LLLL	dddd, MMMM D, YYYY h:mm A	Thursday, August 16, 2018 8:02 PM
l	    M/D/YYYY	                8/16/2018
ll	    MMM D, YYYY	                Aug 16, 2018
lll	    MMM D, YYYY h:mm A	        Aug 16, 2018 8:02 PM
llll	ddd, MMM D, YYYY h:mm A	    Thu, Aug 16, 2018 8:02 PM

*/
String.prototype.toLocalDate = function (format = "LLL") {
    return moment
        .utc(this, "YYYYMMDDHH:mm:ss") // parse stringa UTC
        .local()                        // converte al fuso locale
        .format(format);                // format finale
}
/***********************************DATE********************************************************************/
Date.prototype.ddMMyyyyHHmmss = function () {
    var day = this.getDate().toString().padStart(2, "0");
    var month = (this.getMonth() + 1).toString().padStart(2, "0");
    var year = this.getFullYear();
    var hours = this.getHours().toString().padStart(2, "0");
    var minutes = this.getMinutes().toString().padStart(2, "0");
    var seconds = this.getSeconds().toString().padStart(2, "0");
    return day + month + year + hours + minutes + seconds;
}

Date.prototype.toFormatString = function (format) {
    const [day, month, year, hours, minutes, seconds] = this.split();
    format = format.replace("dd", day).replace("DD", day);
    format = format.replace("MM", month);
    format = format.replace("yyyy", year).replace("YYYY", year);
    format = format.replace("hh", hours).replace("HH", hours);
    format = format.replace("mm", minutes);
    format = format.replace("ss", seconds).replace("SS", seconds);
    return format;

}

Date.prototype.split = function () {
    var day = this.getDate().toString().padStart(2, "0");
    var month = (this.getMonth() + 1).toString().padStart(2, "0");
    var year = this.getFullYear();
    var hours = this.getHours().toString().padStart(2, "0");
    var minutes = this.getMinutes().toString().padStart(2, "0");
    var seconds = this.getSeconds().toString().padStart(2, "0");
    return [day, month, year, hours, minutes, seconds];
}


/*****************************ARRAY*****************************************************************************************************/
Array.prototype.removeIf = function (condition) {
    var i = this.length;
    while (i--) {
        if (condition(this[i], i)) {
            this.splice(i, 1);
        }
    }
}

Array.prototype.update = function (newArray) {
    if (this.length != 0) {
        this.clear();
    }

    if (newArray.length != 0) {
        this.push(...newArray);
    }

}

Array.prototype.clear = function () {
    if (this.length != 0) {
        this.splice(0, this.length);
    }
}

//https://stackoverflow.com/questions/15125920/how-to-get-distinct-values-from-an-array-of-objects-in-javascript
Array.prototype.distinctBy = function (propertyName) {
    return [...new Map(this.map(item => [propertyName == null ? item : item[propertyName], item])).values()]
}

Array.prototype.Equal = function (b) {
    if (this === b) return true;
    if (this == null || b == null) return false;
    if (this.length !== b.length) return false;

    // If you don't care about the order of the elements inside
    // the array, you should sort both arrays here.
    // Please note that calling sort on an array will modify that array.
    // you might want to clone your array first.

    for (var i = 0; i < this.length; ++i) {
        if (this[i] !== b[i]) return false;
    }
    return true;
}

Array.prototype.toMap = function (key) {
    return this.reduce((map, obj) => ({ ...map, [obj[key]]: obj }), {});

}




/*****************************INTEGER - SERVICETYPES*****************************************************************************************************/

Number.prototype.isCloud = function () {
    return ONEServiceTypeInfo[this].mainType == 1;
}

Number.prototype.isCloudS3 = function () {
    return [
        ONEServiceType.Cloud_AmazonS3Storage,
        ONEServiceType.Cloud_IperiusS3Storage,
        ONEServiceType.Cloud_S3CompatibleStorage
    ].includes(this);
}


Number.prototype.isMicrosoft = function () {
    return ONEServiceTypeInfo[this].mainType == ONEServiceType.Microsoft;
}

Number.prototype.isMicrosoft365 = function () {
    return this.isMicrosoft() && !this.isExchangeOnPremises();
}
Number.prototype.isExchangeOnPremises = function () {
    return [
        ONEServiceType.Microsoft_ExchangeOnPremises,
        ONEServiceType.Microsoft_ExchangeOnPremisesEWS,
    ].includes(this);
}

Number.prototype.isExchange = function () {
    return [
        ONEServiceType.Microsoft_ExchangeOnPremises,
        ONEServiceType.Microsoft_ExchangeOnPremisesEWS,
        ONEServiceType.Microsoft_Exchange365
    ].includes(this);
}

Number.prototype.isEmail = function () {
    return ONEServiceTypeInfo[this].mainType == ONEServiceType.Email;
}
Number.prototype.isDatabase = function () {
    return [ONEServiceType.Database_SQLServer, ONEServiceType.Database_MySQL].includes(this);
}
Number.prototype.isSimpleFileNFolderType = function () {

    switch (this) {
        case ONEServiceType.FileFolder:
        case ONEServiceType.Network:
        case ONEServiceType.FTP:

        case ONEServiceType.Cloud_GoogleDrive:
        case ONEServiceType.Cloud_S3CompatibleStorage:
        case ONEServiceType.Cloud_IperiusS3Storage:
        case ONEServiceType.Cloud_AmazonS3Storage:
        case ONEServiceType.Cloud_Dropbox:
        case ONEServiceType.Cloud_OneDrive:
        case ONEServiceType.Cloud_AzureBlob:
        case ONEServiceType.Cloud_AzureFile:

        case ONEServiceType.Microsoft_SharePoint:
        case ONEServiceType.Microsoft_Teams:
        case ONEServiceType.Microsoft_OneDriveForBusiness:
            return true;
    }
    return false;
}

//this deve essere la destinazione del restore/sorgente di backup
Number.prototype.isRestoreFile = function () {
    switch (this) {
        case ONEServiceType.FileFolder:
        case ONEServiceType.Network:
        case ONEServiceType.Microsoft_SharePoint:
        case ONEServiceType.Microsoft_Teams:
        case ONEServiceType.Microsoft_OneDriveForBusiness:
            return true;
    }
    return false;
}

Number.prototype.getSeparator = function () {
    switch (this) {
        case ONEServiceType.FileFolder:
        case ONEServiceType.Network:
            return "\\"
        default:
            return "/"
    }
}

/**********************************INTEGER - FILEFOLDERENTITYTYPE**********************************************************************************/
Number.prototype.getMetroIcon = function (path) {
    if (isValid(path)) {
        var slash = path.getSeparator();

        //Caso 1 : questo nodo corrisponde ad un drive di filefolder (C:\, L:\) ecc...
        if (slash === "\\" && path.length === 3)
            return "mif-drive2";
    }
    switch (this) {
        case FileFolderEntityType.FN_File:
            return "mif-file-empty";
        case FileFolderEntityType.Cloud_File: //CLOUD_FILE
            return "mif-file-empty";
        case FileFolderEntityType.SP_File: //SP_FILE
            return "mif-file-empty";
        case FileFolderEntityType.FTP_File: //FTP_FILE
            return "mif-file-empty";
        case FileFolderEntityType.FN_Folder: //FN_FOLDER
            return "mif-folder";
        case FileFolderEntityType.Cloud_Folder: //CLOUD_FOLDER
            return "mif-folder";
        case FileFolderEntityType.SP_Folder: //SP_FOLDER
            return "mif-folder";
        case FileFolderEntityType.FTP_Folder: //FTP_FOLDER
            return "mif-folder";
        case FileFolderEntityType.Cloud_Root: //cloud root
            return "mif-cloud";
        case FileFolderEntityType.SP_Site_All: // sp_root
            return "mif-cloud";
        case FileFolderEntityType.Cloud_Bucket: //cloud bucket
            return "mif-drive2";
        case FileFolderEntityType.SP_Site: //sp_site
            return "mif-earth";
        case FileFolderEntityType.SP_Library: //sp_library
            return "mif-books";
        case FileFolderEntityType.MT_Team_AllTeams:
            return "mif-groups";
        case FileFolderEntityType.MT_Team:
            return "mif-groups";
        case FileFolderEntityType.MT_Channel:
            return "mif-chat-bubble-outline";
        case FileFolderEntityType.CloudAccount:
            return "mif-person";
        case FileFolderEntityType.CloudAccount_All:
            return "mif-groups";
        case FileFolderEntityType.Mailbox_User:
        case FileFolderEntityType.Mailbox_Impersonation:
            return "mif-person";
        case FileFolderEntityType.Mailbox_Shared:
            return "mif-share-circle";
        case FileFolderEntityType.Mailbox_Group:
            return "mif-groups";
        case FileFolderEntityType.MT_Team_All:
            return "mif-earth";
        case FileFolderEntityType.Database:
            return "mif-database";
        case FileFolderEntityType.VirtualMachine:
            return "mif-computer";
        case FileFolderEntityType.Disk:
            return "mif-drive";
        case FileFolderEntityType.DiskPartition:
            return "mif-database";
        case FileFolderEntityType.Mailbox_All:
            return "mif-groups";
        default:
            return 'mif-question';
    }
}

Number.prototype.isFile = function () {

    switch (this) {
        case FileFolderEntityType.FN_File:
            return true;
        case FileFolderEntityType.Cloud_File:
            return true;
        case FileFolderEntityType.SP_File:
            return true;
        case FileFolderEntityType.FTP_File:
            return true;
        default:
            return false;

    }
}

Number.prototype.isEntityTypeSelectable = function () {

    switch (this) {
        case FileFolderEntityType.FN_File:
        case FileFolderEntityType.FN_Folder:
        case FileFolderEntityType.Cloud_Bucket:
        case FileFolderEntityType.Cloud_File:
        case FileFolderEntityType.Cloud_Folder:
        case FileFolderEntityType.CloudAccount:

        case FileFolderEntityType.SP_File:
        case FileFolderEntityType.SP_Folder:
        case FileFolderEntityType.SP_Site:
        case FileFolderEntityType.SP_Library:

        case FileFolderEntityType.MT_Team:
        case FileFolderEntityType.MT_Channel:

        case FileFolderEntityType.FTP_File:
        case FileFolderEntityType.FTP_Folder:


        case FileFolderEntityType.Database:
        case FileFolderEntityType.Disk:
        case FileFolderEntityType.DiskPartition:
        case FileFolderEntityType.VirtualMachine:

        case FileFolderEntityType.Mailbox_User:
        case FileFolderEntityType.Mailbox_Group:
        case FileFolderEntityType.Mailbox_Shared:
            return true;
    }
    console.debug(this + " -> false");
    return false;
}

Number.prototype.expandChildren = function () {
    switch (this) {
        case FileFolderEntityType.FN_File:
        case FileFolderEntityType.Cloud_File:
        case FileFolderEntityType.CloudAccount:

        case FileFolderEntityType.SP_File:
        case FileFolderEntityType.SP_Site:

        case FileFolderEntityType.MT_Channel:

        case FileFolderEntityType.FTP_File:


        case FileFolderEntityType.Database:
        case FileFolderEntityType.VirtualMachine:

        case FileFolderEntityType.Mailbox_User:
        case FileFolderEntityType.Mailbox_Group:
        case FileFolderEntityType.Mailbox_Shared:
            return false;
    }
    return true;
}

/****************************************************NUMBER - RESULTVALUE****************************/
Number.prototype.getResultValueInfo = function () {
    var info = {
        color: "fg-gray",
        label: ""
    };
    switch (this) {
        case ResultValue.OK:
            info.color = "fg-green";
            info.label = "Completed successfully";
            break;
        case ResultValue.SomeWarnings:
            info.color = "fg-orange";
            info.label = "Some Warnings";
            break;
        case ResultValue.TerminatedAbnormally:
            info.color = "fg-red";
            info.label = "Abnormally terminated";
            break;
        case ResultValue.Aborted:
            info.color = "fg-red";
            info.label = "Aborted by user";
            break;
        case ResultValue.Error:
            info.color = "fg-red";
            info.label = "Finished with errors";
            break;
        case ResultValue.Running:
            info.color = "fg-primary";
            info.label = "Running";
            break;
        case ResultValue.NeverExecuted:
            info.color = "fg-gray";
            info.label = "Never executed";
            break;
        case ResultValue.FeatureNotEnabled:
            info.color = "fg-red";
            info.label = "Feature not enabled";
    }

    return info;
}


/****************************************************MISCELLANEOUS ***************************************************************/
VueRouter.prototype.removeHash = function () {
    var currentURL = this.history.current.path;
    var originalURL = currentURL.split("#")[0];
    this.replace({ path: originalURL }).catch((err) => {
        // Ignora l'errore NavigationDuplicated
        if (err.name !== 'NavigationDuplicated') {
            console.writeError(err);
        }
    });
}